/* GENERATED from bundle-builder-app/shared/ruleset.js by `npm run theme:rules` (bundle-builder-app/scripts/theme-rules.mjs).
   Do not edit: change shared/ruleset.js and regenerate (test/theme-rules.test.mjs fails when the two drift).
   The Functions' own rules for the storefront: window.GSIBundleRules. */
(() => {
  if (window.GSIBundleRules) return;
/**
 * Bundle Builder — the RULESET READER.
 *
 * One module, three consumers: the Validation Function, the Discount Function
 * and the test matrix. `snippets/bundle-ruleset.liquid` in the theme emits the
 * SAME JSON shape from the admin metaobject, so the builder UI reads the same
 * document the Functions do (plan §3.2: one source of truth).
 *
 * The compiled ruleset document (written onto each Function owner's
 * `$app:bundle-builder` / `ruleset` JSON metafield by `scripts/ruleset-sync.mjs`):
 *
 * {
 *   "version": 1,
 *   "collectionIds": ["gid://shopify/Collection/…", …],   // input-query variable
 *   "groups": [
 *     { "key": "wheel",  "label": "GSI wheel",  "collectionId": "gid://…", "role": "REQUIRED",   "restricted": false },
 *     { "key": "base",   "label": "wheel base", "collectionId": "gid://…", "role": "QUALIFYING", "restricted": true  },
 *     { "key": "pedals", "label": "pedal set",  "collectionId": "gid://…", "role": "QUALIFYING", "restricted": true  },
 *     { "key": "gloves", "label": "gloves",     "collectionId": "gid://…", "role": "ATTACHED",   "restricted": false, "maxPerBundle": 3 },
 *     { "key": "qr",     "label": "quick release", "collectionId": "gid://…", "role": "ATTACHED", "restricted": true, "cappedBy": "wheel", "followsGroup": "base",
 *       "message": "Each quick release needs its own GSI wheel in your cart. Add a GSI wheel, or remove the quick release." },
 *     { "key": "hub",    "label": "Simucube Link Hub", "collectionId": "gid://…", "role": "ATTACHED", "restricted": true, "maxPerBundle": 1, "cappedBy": "wheel",
 *       "extra": { "mode": "any", "triggers": [ { "group": "base", "supplier": "simucube" }, { "group": "pedals", "supplier": "simucube" } ] } }
 *   ],
 *   "minQualifyingItems": 2,
 *   "discountPercent": 10,
 *   "messages": { … optional overrides, see DEFAULT_MESSAGES … }
 * }
 *
 * Two relations, deliberately separate (D40, 2026-09-22):
 *   cappedBy     — the COUNT CAP the Functions enforce: count(g) <= count(cappedBy).
 *                  The quick release needs a WHEEL in the cart, bundle or not, one per
 *                  wheel; the discount caps its discounted units at the cap group's
 *                  discounted units.
 *   followsGroup — the builder's FOLLOW relation, which the Functions never read:
 *                  which pick the group's step waits on, is auto-selected with, and is
 *                  fit-matched against (D37/D38 — the QR fits the BASE, not the wheel).
 *                  Absent = follows the cap group, so gloves and any future group
 *                  behave exactly as before; only the QR sets both.
 *   extra        — D64 (2026-09-23): an EXTRA is a group the builder offers as a TICKED
 *                  box, one unit per bundle, when its triggers are met — the Simucube
 *                  Link Hub when a Simucube base OR ActivePedal is picked ("any"), the
 *                  Ethernet switch when BOTH are ("all"). A trigger = { group, supplier }:
 *                  the customer's pick in `group` has that `bundle_builder.supplier`.
 *                  The parser REQUIRES the ordinary fields on an extra: ATTACHED,
 *                  restricted (blocked without a wheel), cappedBy set, maxPerBundle 1
 *                  (one discounted unit). AND (planner 2026-09-23, overriding the first
 *                  cut) the Functions enforce the TRIGGER: an extra in the cart whose
 *                  triggers are not met is refused, and never discounted — a $100 hub
 *                  is priced on the assumption it ships with a Simucube device. The
 *                  match is group (collection membership) + supplier (the product's
 *                  `bundle_builder.supplier`, read by the input query) — never
 *                  productType (D21). Nothing brand-specific: another brand's hub is
 *                  another trigger row.
 *   stepWith     — D76 (2026-09-25): builder only, the Functions never read it. The
 *                  group has no step of its own: its cards sit INSIDE another group's
 *                  step, under that step's own cards — GSI's AH hub extensions in the
 *                  quick-release step, retitled "Mounting". A single optional pick.
 *                  The rules come from the ordinary fields (the AH hubs: ATTACHED,
 *                  not restricted, maxPerBundle 1 — one discounted per bundle, like a
 *                  glove). The parser requires an ATTACHED, non-extra group hosted by
 *                  a real, non-extra group that is not itself hosted.
 *
 * Entitlement is decided ONLY from collection membership (plan §3.1 rule 2).
 * Nothing in this module reads line-item properties or cart attributes, and
 * nothing here must ever start to.
 */

const ROLES = Object.freeze({
  REQUIRED: 'REQUIRED',
  QUALIFYING: 'QUALIFYING',
  ATTACHED: 'ATTACHED',
});

/**
 * D163 (Luka 2026-09-28, permanent): the first pair of gloves is FREE with every qualifying bundle — per bundle, this
 * many units of the group are 100 % off, the HIGHEST-priced first, taken from inside the group's own cap (gloves: 1
 * free + 2 at the bundle rate; beyond 3 per bundle, full price). A ruleset document may override it with
 * `free: { <group key>: <units> }`; absent, this default applies. Only ATTACHED groups, never an extra. The builder
 * (assets/bundle-builder.js, totals) mirrors the same default.
 */
const DEFAULT_FREE = Object.freeze({ gloves: 1 });

/** Precedence when a product sits in more than one group's collection. */
const ROLE_PRIORITY = { REQUIRED: 0, QUALIFYING: 1, ATTACHED: 2 };

const DEFAULT_MESSAGES = Object.freeze({
  // {label} = the restricted group's label; {required} = the label of the group
  // that CAPS it (the wheel for bases, pedals and — since D40 — the quick release).
  // Worded to be true for every restricted group AND both ways round: the
  // Function cannot tell an add from a remove, so this is also what a customer
  // reads when they try to remove the wheel from under a base or a QR (A22).
  // "As part of a bundle" was framing, never the rule (planner, 2026-09-22).
  restrictedAlone:
    'A {label} needs a {required} in your cart. Add a {required}, or remove the {label}.',
  // {count}/{wheels} = how many restricted items vs required items are in the cart.
  restrictedOverCap:
    'Each {label} needs its own {required}. Your cart has {count} × {label} and {wheels} × {required}.',
  // {label} = the extra's label; {triggers} = its trigger list in words. Used only
  // when the extra's own `message` is blank (D51: the written sentence wins).
  extraUntriggered: 'A {label} goes with {triggers}. Add one, or remove the {label}.',
  // {pct} = discountPercent
  discount: '{pct}% off your bundle',
  // D163: the free unit's line in cart and checkout (the first pair of gloves in a qualifying bundle)
  free: 'Free gloves with your bundle',
  // D135: a combined listing's PARENT is a placeholder — its own variants are never for sale. {title} = the
  // listing's title. Shopify's cart already refuses these (/cart/add.js → 422 on live, 2026-09-27); this is the belt.
  placeholder: '{title} needs a color: open it, choose one, and add that to your cart.',
});

/**
 * @typedef {{ group: string, supplier: string }} ExtraTrigger
 * @typedef {{ mode: 'any'|'all', triggers: ExtraTrigger[] }} Extra
 * @typedef {{ key: string, label?: string, collectionId: string, role: 'REQUIRED'|'QUALIFYING'|'ATTACHED', restricted: boolean, maxPerBundle?: number|null, cappedBy?: string|null, followsGroup?: string|null, stepWith?: string|null, message?: string|null, extra?: Extra|null }} Group
 * @typedef {{ version: number, collectionIds: string[], groups: Group[], minQualifyingItems: number, discountPercent: number, free: Record<string, number>, messages: Record<string,string> }} Ruleset
 */

/**
 * Parse + validate a ruleset document. Throws on anything that would make the
 * Functions misbehave silently — a loud failure in the Dev Dashboard beats a
 * quiet fail-open on the hard requirement (D7).
 * @param {unknown} raw
 * @returns {Ruleset}
 */
function parseRuleset(raw) {
  if (raw == null || typeof raw !== 'object') {
    throw new Error('ruleset: metafield is missing or not an object');
  }
  const doc = /** @type {any} */ (raw);
  if (!Array.isArray(doc.groups) || doc.groups.length === 0) {
    throw new Error('ruleset: groups[] is missing or empty');
  }
  const groups = doc.groups.map((g, i) => {
    if (!g || typeof g !== 'object') throw new Error(`ruleset: groups[${i}] is not an object`);
    if (typeof g.key !== 'string' || !g.key) throw new Error(`ruleset: groups[${i}].key missing`);
    if (typeof g.collectionId !== 'string' || !g.collectionId.startsWith('gid://shopify/Collection/')) {
      throw new Error(`ruleset: group "${g.key}" collectionId must be a Collection GID`);
    }
    if (!ROLE_PRIORITY.hasOwnProperty(g.role)) {
      throw new Error(`ruleset: group "${g.key}" role must be REQUIRED | QUALIFYING | ATTACHED`);
    }
    const maxPerBundle =
      g.maxPerBundle == null ? null : Number.isInteger(g.maxPerBundle) && g.maxPerBundle >= 0 ? g.maxPerBundle : NaN;
    if (Number.isNaN(maxPerBundle)) throw new Error(`ruleset: group "${g.key}" maxPerBundle must be a non-negative integer`);
    const cappedBy = g.cappedBy == null || g.cappedBy === '' ? null : String(g.cappedBy);
    const followsGroup = g.followsGroup == null || g.followsGroup === '' ? null : String(g.followsGroup);
    const stepWith = g.stepWith == null || g.stepWith === '' ? null : String(g.stepWith);
    // D51 (Luka 2026-09-22): a restricted group's refusal is PLAIN WRITTEN TEXT,
    // emitted verbatim whenever its rule is broken (alone or over the cap). No
    // category name is ever inserted into a sentence; the {label} templates in
    // DEFAULT_MESSAGES remain only as the fallback for a blank field.
    const message = typeof g.message === 'string' && g.message.trim() ? g.message.trim() : null;
    const extra = parseExtra(g.extra, g.key);
    return {
      key: g.key,
      label: typeof g.label === 'string' && g.label ? g.label : g.key,
      collectionId: g.collectionId,
      role: g.role,
      restricted: g.restricted === true,
      maxPerBundle,
      cappedBy,
      followsGroup,
      stepWith,
      message,
      extra,
    };
  });
  const keys = new Set();
  const cols = new Set();
  for (const g of groups) {
    if (keys.has(g.key)) throw new Error(`ruleset: duplicate group key "${g.key}"`);
    keys.add(g.key);
    // F3 (cloud review): one collection, one group — two groups on one collection would classify by list order
    if (cols.has(g.collectionId)) throw new Error(`ruleset: group "${g.key}" shares its collection with another group`);
    cols.add(g.collectionId);
  }
  const required = groups.filter((g) => g.role === ROLES.REQUIRED);
  if (required.length !== 1) throw new Error('ruleset: exactly one REQUIRED group is needed');
  if (required[0].restricted) throw new Error('ruleset: the REQUIRED group must not be restricted');
  for (const g of groups) {
    // D13: an ATTACHED group that rides the discount without qualifying for it is
    // a farming vector unless its count is CAPPED by a group that does not farm.
    // D35/D40 (the quick release) is exactly that shape: restricted + ATTACHED,
    // capped by the WHEELS — `count(qr) <= count(wheels)` (plan §3.4, §11ab). An
    // uncapped restricted ATTACHED group is still rejected.
    if (g.cappedBy != null) {
      const cap = groups.find((x) => x.key === g.cappedBy);
      if (!cap) throw new Error(`ruleset: group "${g.key}" cappedBy "${g.cappedBy}" is not a group`);
      if (cap.key === g.key || cap.role === ROLES.ATTACHED) {
        throw new Error(`ruleset: group "${g.key}" must be capped by a REQUIRED or QUALIFYING group`);
      }
      if (!g.restricted) throw new Error(`ruleset: group "${g.key}" has cappedBy but is not restricted`);
    }
    if (g.role === ROLES.ATTACHED && g.restricted && g.cappedBy == null) {
      throw new Error(`ruleset: restricted ATTACHED group "${g.key}" needs cappedBy (D13/D35)`);
    }
    // D40: followsGroup refines WHICH pick a capped group follows in the builder.
    // Same guards as cappedBy — a typo here would silently orphan the step (the
    // builder would wait on a pick that never comes) — plus: it only means
    // something on a capped group.
    if (g.followsGroup != null) {
      if (g.cappedBy == null) throw new Error(`ruleset: group "${g.key}" has followsGroup but no cappedBy`);
      const fol = groups.find((x) => x.key === g.followsGroup);
      if (!fol) throw new Error(`ruleset: group "${g.key}" followsGroup "${g.followsGroup}" is not a group`);
      if (fol.key === g.key || fol.role === ROLES.ATTACHED) {
        throw new Error(`ruleset: group "${g.key}" must follow a REQUIRED or QUALIFYING group`);
      }
    }
  }
  // D64: an extra is enforced by the ordinary fields, so the parser insists on them —
  // an extra that was not restricted could be bought alone; without maxPerBundle 1 a
  // second hub would ride the discount; triggers must name real, non-extra groups.
  for (const g of groups) {
    if (!g.extra) continue;
    if (g.role !== ROLES.ATTACHED) throw new Error(`ruleset: extra "${g.key}" must be ATTACHED`);
    if (!g.restricted || g.cappedBy == null) throw new Error(`ruleset: extra "${g.key}" must be restricted with cappedBy`);
    if (g.maxPerBundle !== 1) throw new Error(`ruleset: extra "${g.key}" must have maxPerBundle 1`);
    for (const t of g.extra.triggers) {
      const tg = groups.find((x) => x.key === t.group);
      if (!tg) throw new Error(`ruleset: extra "${g.key}" trigger group "${t.group}" is not a group`);
      if (tg.extra || tg.key === g.key) throw new Error(`ruleset: extra "${g.key}" cannot be triggered by an extra`);
    }
  }
  // D76: a group shown inside another group's step. Builder only, but a typo would
  // silently drop its cards from the page, so it is as loud as followsGroup.
  for (const g of groups) {
    if (g.stepWith == null) continue;
    const host = groups.find((x) => x.key === g.stepWith);
    if (!host || host.key === g.key) throw new Error(`ruleset: group "${g.key}" stepWith "${g.stepWith}" is not another group`);
    if (g.role !== ROLES.ATTACHED || g.extra) throw new Error(`ruleset: group "${g.key}" with stepWith must be an ATTACHED group that is not an extra`);
    if (host.stepWith != null || host.extra) throw new Error(`ruleset: group "${g.key}" stepWith "${host.key}" must be a step of its own`);
  }
  // No cycles: follow cappedBy (and the follow relation) from every group; a
  // repeat is a loop (base ⇄ pedals would cap nothing). Cheap, and its absence
  // would be silent.
  for (const rel of ['cappedBy', 'followsGroup']) {
    for (const start of groups) {
      const seen = new Set([start.key]);
      let cur = start;
      while (cur[rel]) {
        if (seen.has(cur[rel])) throw new Error(`ruleset: ${rel} cycle through group "${cur[rel]}"`);
        seen.add(cur[rel]);
        cur = groups.find((x) => x.key === cur[rel]);
      }
    }
  }
  const minQualifyingItems = doc.minQualifyingItems == null ? 2 : doc.minQualifyingItems;
  if (!Number.isInteger(minQualifyingItems) || minQualifyingItems < 2) {
    throw new Error('ruleset: minQualifyingItems must be an integer >= 2');
  }
  const discountPercent = Number(doc.discountPercent);
  if (!(discountPercent > 0 && discountPercent <= 100)) {
    throw new Error('ruleset: discountPercent must be in (0, 100]');
  }
  // D163: free units per bundle. An explicit map is checked loudly; the default quietly skips a group this ruleset lacks.
  const free = {};
  const explicitFree = doc.free != null;
  if (explicitFree && (typeof doc.free !== 'object' || Array.isArray(doc.free))) throw new Error('ruleset: free must be an object of group key → units');
  for (const [key, n] of Object.entries(explicitFree ? doc.free : DEFAULT_FREE)) {
    const g = groups.find((x) => x.key === key);
    if (!g) { if (explicitFree) throw new Error(`ruleset: free names "${key}", which is not a group`); continue; }
    if (g.role !== ROLES.ATTACHED || g.extra) throw new Error(`ruleset: free group "${key}" must be an ATTACHED group that is not an extra`);
    if (!Number.isInteger(n) || n < 0) throw new Error(`ruleset: free units for "${key}" must be a non-negative integer`);
    if (g.maxPerBundle != null && n > g.maxPerBundle) throw new Error(`ruleset: free units for "${key}" exceed its maxPerBundle`);
    if (n > 0) free[key] = n;
  }
  const collectionIds = Array.isArray(doc.collectionIds) ? doc.collectionIds : groups.map((g) => g.collectionId);
  // F2 (cloud review): the Functions ask inCollections(ids: $collectionIds) — a group whose collection is not in that
  // list never matches a line, so a restricted group would fail OPEN. As loud as a missing ruleset.
  for (const g of groups) {
    if (!collectionIds.includes(g.collectionId)) throw new Error(`ruleset: collectionIds does not include group "${g.key}"'s collection — run ruleset:sync`);
  }
  return {
    version: Number.isInteger(doc.version) ? doc.version : 1,
    collectionIds,
    groups,
    minQualifyingItems,
    discountPercent,
    free,
    messages: { ...DEFAULT_MESSAGES, ...(doc.messages && typeof doc.messages === 'object' ? doc.messages : {}) },
  };
}

/**
 * D64: parse a group's `extra` — null when absent; throws on a malformed one.
 * Accepts the compiled shape ({ mode, triggers: [{ group, supplier }] }).
 * @param {unknown} raw
 * @param {string} key
 * @returns {Extra|null}
 */
function parseExtra(raw, key) {
  if (raw == null || raw === '') return null;
  if (typeof raw !== 'object') throw new Error(`ruleset: group "${key}" extra must be an object`);
  const e = /** @type {any} */ (raw);
  const mode = e.mode === 'all' ? 'all' : e.mode === 'any' ? 'any' : null;
  if (!mode) throw new Error(`ruleset: group "${key}" extra.mode must be "any" or "all"`);
  if (!Array.isArray(e.triggers) || e.triggers.length === 0) throw new Error(`ruleset: group "${key}" extra.triggers must be a non-empty list`);
  const triggers = e.triggers.map((t, i) => {
    const group = t && typeof t.group === 'string' ? t.group.trim() : '';
    const supplier = t && typeof t.supplier === 'string' ? t.supplier.trim().toLowerCase() : '';
    if (!group || !supplier) throw new Error(`ruleset: group "${key}" extra.triggers[${i}] needs group and supplier`);
    return { group, supplier };
  });
  return { mode, triggers };
}

/**
 * D64: the admin text form of the triggers ("base:simucube, pedals:simucube") ⇄ the
 * compiled list. Shared by the sync script and the editor so the two never drift.
 * @param {string|null|undefined} text
 * @returns {ExtraTrigger[]}
 */
function parseTriggerText(text) {
  return String(text || '').split(',').map((s) => s.trim()).filter(Boolean).map((pair) => {
    const [group, supplier] = pair.split(':').map((x) => (x || '').trim());
    return { group, supplier: (supplier || '').toLowerCase() };
  });
}
/** @param {ExtraTrigger[]} triggers */
function triggerText(triggers) {
  return (triggers || []).map((t) => `${t.group}:${t.supplier}`).join(', ');
}
/** Build a group's `extra` from the two admin fields (extra_mode, extra_triggers), or null. */
function extraFromFields(mode, triggersText) {
  const m = mode == null ? '' : String(mode).trim();
  if (!m) return null;
  return { mode: m, triggers: parseTriggerText(triggersText) };
}

/**
 * Build the compiled document from its parts. Used by the sync script and by
 * tests; guarantees `collectionIds` always mirrors `groups`.
 * @param {Omit<Ruleset,'collectionIds'|'version'|'messages'> & { messages?: Record<string,string> }} parts
 */
function compileRuleset(parts) {
  const doc = {
    version: 1,
    collectionIds: parts.groups.map((g) => g.collectionId),
    groups: parts.groups,
    minQualifyingItems: parts.minQualifyingItems,
    discountPercent: parts.discountPercent,
    messages: parts.messages ?? {},
  };
  return parseRuleset(doc);
}

/**
 * Decide which group a cart line belongs to, from `product.inCollections` ONLY.
 * Returns null for lines outside every group (hubs, gift cards, …).
 * @param {Ruleset} ruleset
 * @param {any} line  A Function input cart line (`merchandise.product.inCollections`).
 * @returns {Group|null}
 */
function classifyLine(ruleset, line) {
  const merch = line && line.merchandise;
  if (!merch || merch.__typename !== 'ProductVariant') return null;
  // D135: a placeholder line belongs to NO group — never a wheel, never a qualifier, never discounted.
  if (isPlaceholder(line)) return null;
  const memberships = merch.product && Array.isArray(merch.product.inCollections) ? merch.product.inCollections : [];
  // one pass over the line's memberships, no arrays or sets per line (the Functions' instruction budget, lineClassifier)
  const byCollection = groupsByCollection(ruleset);
  let best = null;
  for (const m of memberships) {
    if (!m || !m.isMember) continue;
    const g = byCollection.get(m.collectionId);
    if (!g) continue;
    // F3 (cloud review): within one role a RESTRICTED group wins — a product in two groups is never let out of D7 by
    // the order the groups are listed in (the store matrix pre-flight refuses such a product; this is the belt)
    if (!best || ROLE_PRIORITY[g.role] < ROLE_PRIORITY[best.role] || (g.role === best.role && g.restricted && !best.restricted)) best = g;
  }
  return best;
}

/** collection GID → its group, built once per parsed ruleset (one collection, one group: parseRuleset's F3). */
const BY_COLLECTION = new WeakMap();
/** @param {Ruleset} ruleset @returns {Map<string, Group>} */
function groupsByCollection(ruleset) {
  let m = BY_COLLECTION.get(ruleset);
  if (!m) { m = new Map(ruleset.groups.map((g) => [g.collectionId, g])); BY_COLLECTION.set(ruleset, m); }
  return m;
}

/**
 * D135: is this line a combined listing's PARENT (a placeholder whose own variants are never sold)? Read from the
 * product's `bundle_builder.combined_listing` metafield as the input query aliases it (`product.combined { value }`),
 * which the App Home sets from Shopify's combinedListingRole (the Function input has no such field). A missing or
 * different value reads as an ordinary product — the App Home's auto-flag and its Products badge keep that short.
 * @param {any} line
 */
function isPlaceholder(line) {
  const p = line && line.merchandise && line.merchandise.product;
  const v = p && p.combined && p.combined.value;
  return typeof v === 'string' && v.trim().toLowerCase() === 'parent';
}

/**
 * A cart line's supplier, from the product's `bundle_builder.supplier` metafield as
 * the input query aliases it (`product.supplier { value }`). Lower-cased; '' if unset.
 * @param {any} line
 */
function lineSupplier(line) {
  const p = line && line.merchandise && line.merchandise.product;
  const v = p && p.supplier && p.supplier.value;
  return typeof v === 'string' ? v.trim().toLowerCase() : '';
}

/**
 * Each cart line classified ONCE per Function run (live 2026-10-21 22:26 CT: a Morocco cart of 19 lines, a Simucube
 * bundle with 13 pairs of gloves, ran out of the discount Function's 11,000,000-instruction budget: every extra's
 * trigger check re-classified every line, so the work grew with lines × triggers and no discount applied). Returns
 * `groupOf(line)`, read by countByGroup and triggersMet; a line it wasn't built with is classified on the spot.
 * @param {Ruleset} ruleset
 * @param {any[]} lines
 * @returns {(line: any) => Group|null}
 */
function lineClassifier(ruleset, lines) {
  const groups = new Map();
  for (const line of lines) groups.set(line, classifyLine(ruleset, line));
  return (line) => (groups.has(line) ? /** @type {Group|null} */ (groups.get(line)) : classifyLine(ruleset, line));
}

/**
 * D64: is an extra's trigger met by the cart? A trigger { group, supplier } is met
 * when some line classified into `group` carries that supplier. mode any = at
 * least one trigger; all = every trigger. Non-extras are always "met".
 * @param {Ruleset} ruleset
 * @param {Group} g
 * @param {any[]} lines
 */
function triggersMet(ruleset, g, lines, groupOf = (line) => classifyLine(ruleset, line)) {
  if (!g.extra) return true;
  // the cheap tests first: only a line of the trigger's supplier is classified (Function instruction budget, below)
  const met = (t) => lines.some((line) => {
    if ((Number(line.quantity) || 0) <= 0 || lineSupplier(line) !== t.supplier) return false;
    const lg = groupOf(line);
    return !!lg && lg.key === t.group;
  });
  return g.extra.mode === 'all' ? g.extra.triggers.every(met) : g.extra.triggers.some(met);
}

/**
 * Sum quantities per group across the cart.
 * @param {Ruleset} ruleset
 * @param {any[]} lines
 * @returns {Map<string, number>}  group key → total units
 */
function countByGroup(ruleset, lines, groupOf = (line) => classifyLine(ruleset, line)) {
  const counts = new Map(ruleset.groups.map((g) => [g.key, 0]));
  for (const line of lines) {
    const g = groupOf(line);
    if (!g) continue;
    const q = Number(line.quantity) || 0;
    counts.set(g.key, (counts.get(g.key) || 0) + q);
  }
  return counts;
}

/** @param {Ruleset} ruleset */
function requiredGroup(ruleset) {
  return /** @type {Group} */ (ruleset.groups.find((g) => g.role === ROLES.REQUIRED));
}

/**
 * Supplier DISPLAY names for sentences (the key is what products carry; the name
 * is what a person reads). Mirrors home/model.js's list — keep the two equal.
 */
const SUPPLIER_NAMES = Object.freeze({ moza: 'Moza', vrs: 'VRS', simucube: 'Simucube', heusinkveld: 'Heusinkveld', other: 'Other' });

/**
 * A group label as it reads INSIDE a sentence. D51 made labels titles
 * ("Mounting", "Wheel base"), so a plain title-cased label drops its capital
 * ("a mounting", "a wheel base"); a label with capitals of its own is a proper
 * name and stays as written ("a GSI wheel", "a Simucube Link Hub").
 * @param {string} label
 */
function sentenceLabel(label) {
  const s = String(label || '');
  if (!s) return s;
  const rest = s.slice(1);
  if (/[A-Z]/.test(rest)) return s;
  return s.charAt(0).toLowerCase() + rest;
}

/** "a Simucube wheel base or a Simucube pedal set" — for the fallback sentence only. */
function triggerWords(ruleset, g) {
  const parts = g.extra.triggers.map((t) => {
    const tg = ruleset.groups.find((x) => x.key === t.group);
    const who = SUPPLIER_NAMES[t.supplier] || t.supplier;
    return `a ${who} ${sentenceLabel(tg ? tg.label : t.group)}`;
  });
  return parts.join(g.extra.mode === 'all' ? ' and ' : ' or ');
}

function fill(template, vars) {
  return template.replace(/\{(\w+)\}/g, (m, k) => {
    if (k in vars) return String(vars[k]);
    const lower = k.charAt(0).toLowerCase() + k.slice(1);
    if (k[0] === k[0].toUpperCase() && lower in vars) {
      const v = String(vars[lower]);
      return v.charAt(0).toUpperCase() + v.slice(1);
    }
    return m;
  });
}

/**
 * THE VALIDATION RULE (plan §3.4 / §3.5, D7, D35, D40):
 *   for every restricted group g:  count(g) <= count(g.cappedBy ?? REQUIRED)
 * A lone base (0 wheels) fails; 2 bases + 1 wheel fails; a quick release with
 * no WHEEL fails (D40 — cappedBy: 'wheel'; a wheel + QR with no base passes at
 * full price); a line at quantity 2 counts as 2. Wheels, gloves and anything
 * outside the groups never block.
 *
 * @param {Ruleset} ruleset
 * @param {any[]} lines
 * @returns {string[]}  error messages (empty = checkout may proceed)
 */
function validateCart(ruleset, lines) {
  const groupOf = lineClassifier(ruleset, lines);
  const counts = countByGroup(ruleset, lines, groupOf);
  const req = requiredGroup(ruleset);
  const errors = [];
  // D135: a combined listing's placeholder is refused outright, whatever else is in the cart.
  for (const line of lines) {
    if ((Number(line.quantity) || 0) > 0 && isPlaceholder(line)) {
      const title = String((line.merchandise.product && line.merchandise.product.title) || 'This item').trim() || 'This item';
      errors.push(fill(ruleset.messages.placeholder, { title }));
    }
  }
  for (const g of ruleset.groups) {
    if (!g.restricted) continue;
    // A mistyped cappedBy must be as loud as a missing ruleset: falling back to
    // the REQUIRED group would silently LOOSEN the cap (count(wheels) > count(bases)).
    // parseRuleset already rejects it; this is the belt to that brace.
    const capGroup = g.cappedBy ? ruleset.groups.find((x) => x.key === g.cappedBy) : req;
    if (!capGroup) throw new Error(`ruleset: group "${g.key}" cappedBy "${g.cappedBy}" is not a group`);
    const wheels = counts.get(capGroup.key) || 0;
    const count = counts.get(g.key) || 0;
    if (count === 0) continue;
    // D64: an extra without its trigger is refused, whatever the wheel count.
    if (!triggersMet(ruleset, g, lines, groupOf)) {
      errors.push(g.message || fill(ruleset.messages.extraUntriggered, { label: sentenceLabel(g.label), triggers: triggerWords(ruleset, g) }));
      continue;
    }
    if (count <= wheels) continue;
    // D51: the group's own sentence, verbatim, for both the lone and the over-cap
    // case; the {label}/{required} templates only when the field is blank.
    if (g.message) { errors.push(g.message); continue; }
    const vars = { label: sentenceLabel(g.label), required: sentenceLabel(capGroup.label), count, wheels };
    errors.push(fill(wheels === 0 ? ruleset.messages.restrictedAlone : ruleset.messages.restrictedOverCap, vars));
  }
  return errors;
}

/**
 * THE DISCOUNT MATHS (plan §3.4 + §3.7, D10/D13/D14):
 *
 *   W        = count(REQUIRED)
 *   perBundle = minQualifyingItems - 1          (v1: 1 — the wheel plus at least one qualifier)
 *   bundles  = the largest k <= W with  Σ_g min(count(g), k) >= k × perBundle
 *              — D10: at most ONE of each qualifying group per bundle, so a group can fill at most k
 *              bundles (cloud review F1). At perBundle 1 this is exactly min(W, Σ min(count(g), W)).
 *   q_g      = min(count(g), bundles)          for each QUALIFYING group (also the defensive cap: the
 *                                               discount never rewards a cap violation if the
 *                                               validation is detached)
 *
 *   discounted wheels     = the `bundles` HIGHEST-priced wheel units (surplus wheel rule)
 *   discounted qualifiers = q_g units per group, highest-priced first
 *   discounted attached   = min(count(a), maxPerBundle_a × bundles) units, highest-priced first;
 *                           a group with cappedBy is further capped at the DISCOUNTED units
 *                           of its cap group (D40: no more discounted QRs than discounted
 *                           WHEELS — so a QR in a wheel + pedals bundle is discounted, and a
 *                           wheel + QR with no qualifier has zero bundles and nothing is)
 *
 * Returns per-line unit allocations so the Function can emit `cartLine { id, quantity }`
 * targets — a line of 4 gloves with a 3-per-bundle cap gets `quantity: 3`.
 *
 * @param {Ruleset} ruleset
 * @param {any[]} lines  Function input lines with `cost.amountPerQuantity.amount`
 * D163: of a group's discounted units, the first `free[group] × bundles` (highest-priced first) come back as separate
 * allocations marked `free: true` — 100 % off — and the rest at the bundle rate; one line can hold both.
 *
 * @returns {{ bundles: number, allocations: Array<{ lineId: string, quantity: number, groupKey: string, free?: boolean }> }}
 */
function allocateDiscount(ruleset, lines) {
  const req = requiredGroup(ruleset);
  /** @type {Map<string, Array<{lineId:string, unitPrice:number, quantity:number, variant:string}>>} */
  const byGroup = new Map(ruleset.groups.map((g) => [g.key, []]));
  const groupOf = lineClassifier(ruleset, lines);
  for (const line of lines) {
    const g = groupOf(line);
    if (!g) continue;
    const quantity = Number(line.quantity) || 0;
    if (quantity <= 0) continue;
    byGroup.get(g.key).push({
      lineId: line.id,
      unitPrice: Number(line.cost && line.cost.amountPerQuantity && line.cost.amountPerQuantity.amount) || 0,
      quantity,
      variant: String((line.merchandise && line.merchandise.id) || '').split('/').pop(),
    });
  }
  // Highest-priced units first, everywhere. D163: an equal price goes to the LOWER variant id — never the cart's line
  // order, which Shopify keeps newest-first (measured on dev) and the builder cannot see — so the builder's pane can
  // mark the same pair "Free" (and the same one full price) that checkout charges. Same variant: line order (stable).
  const byId = (a, b) => (a.length - b.length) || (a < b ? -1 : a > b ? 1 : 0);
  for (const arr of byGroup.values()) arr.sort((a, b) => b.unitPrice - a.unitPrice || byId(a.variant, b.variant));

  const total = (key) => byGroup.get(key).reduce((n, l) => n + l.quantity, 0);
  const W = total(req.key);
  if (W === 0) return { bundles: 0, allocations: [] };

  const perBundle = ruleset.minQualifyingItems - 1;
  const qualifying = ruleset.groups.filter((g) => g.role === ROLES.QUALIFYING);
  // F1: one of each qualifying group per bundle (D10) — k bundles need k × perBundle qualifiers, at most k per group
  const fits = (k) => qualifying.reduce((n, g) => n + Math.min(total(g.key), k), 0) >= k * perBundle;
  let bundles = W;
  while (bundles > 0 && !fits(bundles)) bundles -= 1;
  if (bundles === 0) return { bundles: 0, allocations: [] };

  /** @type {Array<{ lineId: string, quantity: number, groupKey: string, free?: boolean }>} */
  const allocations = [];
  /** units actually discounted per group — what a cappedBy group is measured against */
  const taken = new Map();
  // D163: the first `freeUnits` of the units taken (highest-priced first) are FREE; the rest take the bundle rate
  const take = (groupKey, units, freeUnits = 0) => {
    let left = units;
    let freeLeft = freeUnits;
    let got = 0;
    for (const l of byGroup.get(groupKey)) {
      if (left <= 0) break;
      const q = Math.min(l.quantity, left);
      const f = Math.min(q, freeLeft);
      if (f > 0) allocations.push({ lineId: l.lineId, quantity: f, groupKey, free: true });
      if (q - f > 0) allocations.push({ lineId: l.lineId, quantity: q - f, groupKey });
      freeLeft -= f;
      left -= q;
      got += q;
    }
    taken.set(groupKey, got);
  };

  take(req.key, bundles);
  // one of each qualifying group per bundle: never more of a group than there are bundles (F1)
  for (const g of qualifying) take(g.key, Math.min(total(g.key), bundles));
  // ATTACHED after every qualifier, so a cappedBy group can read its cap's taken units.
  for (const g of ruleset.groups) {
    if (g.role !== ROLES.ATTACHED) continue;
    // D64: an untriggered extra is never discounted (the validation refuses it anyway;
    // this keeps the maths honest if the validation is ever detached).
    if (g.extra && !triggersMet(ruleset, g, lines, groupOf)) continue;
    let cap = g.maxPerBundle == null ? Infinity : g.maxPerBundle * bundles;
    if (g.cappedBy) cap = Math.min(cap, taken.get(g.cappedBy) || 0);
    take(g.key, Math.min(total(g.key), cap), (ruleset.free[g.key] || 0) * bundles);
  }
  return { bundles, allocations };
}

/** @param {Ruleset} ruleset */
function discountMessage(ruleset) {
  return fill(ruleset.messages.discount, { pct: ruleset.discountPercent });
}

/** D163: the free unit's message. @param {Ruleset} ruleset */
function freeMessage(ruleset) {
  return fill(ruleset.messages.free, { pct: ruleset.discountPercent });
}

  window.GSIBundleRules = Object.freeze({ ROLES, DEFAULT_FREE, DEFAULT_MESSAGES, parseRuleset, parseExtra, parseTriggerText, triggerText, extraFromFields, compileRuleset, classifyLine, isPlaceholder, lineSupplier, lineClassifier, triggersMet, countByGroup, requiredGroup, SUPPLIER_NAMES, sentenceLabel, validateCart, allocateDiscount, discountMessage, freeMessage });
})();
